export default __webpack_public_path__ + "static/media/calendar.e8d8ba12.svg";